var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBixinTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 171,
    viewBox: "0 0 754 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.33 170.364H273.429V4.51221H243.33V170.364Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.486 4.51221H414.826L375.926 58.8028L336.851 4.51221H299.405L357.325 84.4134L294.777 170.364H332.493L375.948 109.686L419.405 170.364H457.117L394.571 84.4134L452.486 4.51221Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.616 170.364H509.719V4.51221H479.616V170.364Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M723.139 0.233398V121.72L573.364 0.233398H548.037V170.79H578.542V48.5267L728.709 170.79H753.644V0.233398H723.139Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.139 124.336C174.139 132.972 167.138 139.975 158.498 139.975H31.1815V30.9495H147.793C149.266 30.9495 150.831 30.9495 152.406 30.9476C160.815 30.9437 167.631 37.7584 167.633 46.1671V52.4596C167.635 60.8644 160.818 67.6811 152.412 67.6811H150.404H88.0252L126.133 98.4987H158.502C167.138 98.4987 174.139 105.5 174.139 114.136V124.336ZM191.313 79.3821L191.022 79.1103L191.247 78.7841C196.215 71.5442 198.63 63.5083 198.63 55.8878V45.2405C198.63 43.9242 198.632 42.4292 198.634 40.8042C198.679 18.3622 180.493 0.139125 158.053 0.133301C156.406 0.133301 154.884 0.133301 153.525 0.133301H0.353027V170.789H163.351C187.872 170.789 205.201 153.125 205.201 129.306L204.944 107.293C204.944 97.7003 199.976 87.5268 191.313 79.3821Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBixinTitle);
export default __webpack_public_path__ + "static/media/home_bixin_title.066346d560554256f8bcb2192ab2add9.svg";
export { ForwardRef as ReactComponent };